import { render, staticRenderFns } from "./MoveRoomScheduleRegisterTab.vue?vue&type=template&id=12cb6f4e&scoped=true&lang=pug"
import script from "./MoveRoomScheduleRegisterTab.vue?vue&type=script&lang=ts"
export * from "./MoveRoomScheduleRegisterTab.vue?vue&type=script&lang=ts"
import style0 from "./MoveRoomScheduleRegisterTab.vue?vue&type=style&index=0&id=12cb6f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cb6f4e",
  null
  
)

export default component.exports